import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import api from "./api";

const createCustomer = async () => {
  const res = await api.post("/stripe/customer");
  return res.data;
};

export const useCreateCustomer = () => {
  return useMutation({
    mutationFn: createCustomer,
  });
};

const createSubscription = async (priceId: string) => {
  const res = await api.post<{ subscriptionId: string; clientSecret: string }>(
    "/stripe/subscription",
    { priceId }
  );
  return res.data;
};

export const useCreateSubscription = () => {
  return useMutation({
    mutationFn: createSubscription,
  });
};

const cancelSubscription = async () => {
  const res = await api.delete("/stripe/subscription");
  return res.data;
};

export const useCancelSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["subscription"],
      });
      queryClient.invalidateQueries({
        queryKey: ["me"],
      });
    },
  });
};

const updateSubscription = async (priceId: string) => {
  const res = await api.put("/stripe/subscription", { priceId });
  return res.data;
};

export const useUpdateSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["subscription"],
      });
      queryClient.invalidateQueries({
        queryKey: ["me"],
      });
    },
  });
};

const reactivateSubscription = async () => {
  const res = await api.post("/stripe/subscription/reactivate");
  return res.data;
};

export const useReactivateSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: reactivateSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["subscription"],
      });
      queryClient.invalidateQueries({
        queryKey: ["me"],
      });
    },
  });
};

const getSubscriptionInfo = async () => {
  const res = await api.get("/stripe/subscription");
  return res.data;
};

export const useGetSubscriptionInfo = () => {
  return useQuery({
    queryFn: getSubscriptionInfo,
    queryKey: ["subscription"],
    placeholderData: keepPreviousData,
  });
};
